export function ChartTooltip({ active, payload, valueLabel }: { active?: boolean; payload?: any[]; valueLabel: string }) {
  if (!active || !payload?.length) return null
  return (
    <div className="rounded-lg border bg-card px-3 py-2 shadow-md text-sm">
      <p className="font-semibold text-card-foreground mb-0.5">{payload[0].payload.name}</p>
      <p className="text-primary">{valueLabel}: <span className="font-bold">{payload[0].value?.toLocaleString('de-DE')}</span></p>
    </div>
  )
}
